import { useMemo } from "react";

import { DrawerStack } from "@components/v2";

import { useSalesV4Context } from "./hooks";
import { TableContent } from "./table-content";
import { TableDrawer } from "./table-drawer";

export const TableContainer = () => {
  const { tableStates, selectedBreakdownIds, setTableStates } =
    useSalesV4Context();

  const drillDownBreakdownIds = useMemo(
    () => selectedBreakdownIds.slice(1),
    [selectedBreakdownIds],
  );

  return (
    <>
      <TableContent
        tableState={tableStates[0]}
        onTableStateChange={(value) => {
          setTableStates(
            tableStates.map((e, index) => (index === 0 ? value : e)),
          );
        }}
      />
      <DrawerStack key={JSON.stringify(drillDownBreakdownIds)}>
        {drillDownBreakdownIds.map((breakdownId, index) => {
          const tableState = tableStates.find(
            (e) => e.selectedBreakdownId === breakdownId,
          );

          return (
            <TableDrawer
              key={breakdownId}
              tableState={tableState}
              index={index}
              onClose={() => {
                setTableStates(tableStates.slice(0, tableStates.length - 1));
              }}
              onTableStateChange={(value) => {
                setTableStates(
                  tableStates.map((e, i) => (i === index + 1 ? value : e)),
                );
              }}
            />
          );
        })}
      </DrawerStack>
    </>
  );
};
